import { DescriptionQuestionRender } from 'components/ZentakeForm/Questions/DescriptionQuestionRender'
import * as React from 'react'

import Ui from '../../ui'
import { hasText } from '../../utils/helpers'
import { ZentakeContext } from '../../utils/ZentakeContext'
import OpacityBg from '../OpacityBg'

function ModalEmailPreview({ isVisible, canDismiss, onClose, message }) {
  const { userDetails } = React.useContext(ZentakeContext)

  if (!isVisible) return null

  return (
    <OpacityBg onClick={canDismiss ? onClose : () => {}}>
      <div className="flex-1 rounded border max-w-xl max-h-11/12 overflow-y-scroll">
        <div className="px-10 pb-10" style={{ backgroundColor: '#f6f6f6' }}>
          <div className="text-txt-emphasis text-base space-y-8">
            {hasText(userDetails?.team?.image) && (
              <div className="flex justify-center">
                <img
                  alt="Workflow logo"
                  className="pt-6"
                  src={userDetails?.team?.image}
                />
              </div>
            )}
            <DescriptionQuestionRender value={message} />
            <div className="text-center">
              <Ui.PrimaryButton>Open Form</Ui.PrimaryButton>
            </div>
          </div>
        </div>
        <div className="bg-white border-t px-3 pt-4 pb-4 text-xs space-y-5">
          <p className="text-txt-emphasis">
            <span className="font-bold">Important Notice:</span> This email
            contains private information. Please do not forward, reply to, or
            share.
          </p>
          <p className="text-txt">
            The information contained in this electronic transmission, and any
            documents attached hereto, contain confidential information That is
            intended only for the use of the recipient(s) to whom they are
            addressed. If you have received this electronic message in error,
            please notify the sender and delete the electronic message. Any
            disclosure, copying, distribution or the taking of any action in
            reliance on the contents of the information received in error is
            strictly prohibited.
          </p>
        </div>
      </div>
    </OpacityBg>
  )
}

export default ModalEmailPreview
